<!-- HTML Template -->
<template>
  <div v-if="is_open">
    <div class="modal-container">
      <div class="photo-container">
        <img :src="full_path" alt="" class="photo-container__photo">
        <a @click="deletePhoto()" class="photo-container__delete"><img src="/img/bin.svg" alt="delete"></a>
      </div>
      <a @click="closeModal()" class="photo-container__close"><img src="/img/close.svg" alt="close"> <span class="subtitle text-primary">{{ $t('common.close') }}</span></a>
      <!-- <p class="photo-container__name text-white">{{name}}</p> -->
    </div>
  </div>
</template>

<!-- Javascript -->
<script>
  export default {
    data() {
        return {
          is_open: false,
          full_path: "",
          id: "",
          name: "",
          type: "",
        }
    },
    computed: {
      
    },
    mounted() {

    },
    created() {
      this.$root.$on('preview_photo', (data) => {
        this.full_path = data.full_path
        this.id = data.id
        this.listing_id = data.listing_id
        this.name = data.name
        this.type = data.type
        this.is_open = true
      });
    },
    methods: {
      closeModal() {
        this.is_open = false
        this.full_path = ""
        this.id = ""
        this.listing_id = ""
        this.name = ""
      },
      getDeletePhotoType() {
        switch(this.type) {
          case 'listing_photos':
            return 'delete_listing_photo';
            break;
          case 'hero_photo':
            return 'delete_hero_photo';
            break;
          case 'company_logo':
            return 'delete_company_logo';
            break;
          case 'overview_photo_first':
            return 'delete_overview_photo_first';
            break;
          case 'overview_photo_second':
            return 'delete_overview_photo_second';
            break;
          case 'agent_profile_photo':
            return 'delete_agent_profile_photo';
            break;
          case 'co_agent_profile_photo':
            return 'delete_co_agent_profile_photo';
            break;
          case 'listing_agent_profile_photo':
            return 'delete_listing_agent_profile_photo';
            break;
          case 'floor_plans':
            return 'delete_floor_plans_photo';
            break;
        }
      },
      deletePhoto() {
        this.$root.$emit('confirmed', this.getDeletePhotoType(), { id: this.id});

        this.closeModal();
      }
    }
  }
</script>
